'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------

/**
  * OpenGraphSummary - Implements the Open Graph protocol
  *
  * The Open Graph protocol enables any web page to become a rich object in a social graph.
  * For instance, this is used on Facebook to allow any web page to have the same functionality as any other object on Facebook.
  *
  *
  * @example
    <OpenGraphSummary data={data}>
  *
  * @param {string} data.type - Optional. The type of the webpage. See: https://stackoverflow.com/questions/9275457/facebook-ogtype-meta-tags-should-i-just-make-up-my-own
  * @param {string} data.siteName - Required. The name of the website.
  * @param {string} data.url - Required. The URL of the webpage.
  * @param {string} data.title - Required. The title of the webpage and it's content.
  * @param {string} data.description - Required. A short description of the webpage. Include summary of the webpage.
  * @param {string} data.image - Required. A unique image that will be used as the banner image while sharing on social media.
  *
  * @version 0.0.1
  * @todo none
  * @see {@link http://ogp.me/|Open Graph Docs}
  */


var OpenGraphSummary = function OpenGraphSummary(props) {
  var data = props.data;
  var sanitized = data.url;

  if (sanitized.endsWith('/')) {
    sanitized = sanitized.substring(0, sanitized.length - 1);
  }

  return _react2.default.createElement(_reactHelmet.Helmet, {
    meta: [// ---- Facebook Open Graph
    // { property: 'fb:app_id', content: '123456789' }, // We haven't yet integrated with Facebook Apps.
    {
      property: 'og:type',
      content: data.type === false ? 'website' : data.type
    }, {
      property: 'og:locale',
      content: 'en_US'
    }, {
      property: 'og:site_name',
      content: data.siteName
    }, {
      property: 'og:url',
      content: sanitized
    }, {
      property: 'og:title',
      content: data.title
    }, {
      property: 'og:description',
      content: data.description
    }, {
      property: 'og:image',
      content: data.image
    }]
  });
}; // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------


OpenGraphSummary.propTypes = process.env.NODE_ENV !== "production" ? {
  data: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types

} : {};
OpenGraphSummary.defaultProps = {
  data: {} // ----------------------------------------------------------------------------
  // --------------------------------------------------------------------- Export
  // ----------------------------------------------------------------------------

};
exports.default = OpenGraphSummary;
module.exports = exports['default'];